export default function IntegrationsSettings() {
  return (
    <div>
      <h2>Integrations</h2>

      <div style={styles.card}>
        Google Calendar + Smart Home integrations
      </div>
    </div>
  );
}

const styles = {
  card: {
    background: "#fff",
    padding: "20px",
    borderRadius: "12px",
    marginTop: "15px",
  },
};
